import Nav from "./Component/Nav/Nav"
import SectionMain from "./Component/SectionMain/SectionMain"
import Footer from "./Component/Footer/Footer"
import './App.css';

function App() {
  return (
    <div className="App">
    <main> 
<Nav/>
<SectionMain/>
<Footer/>
    </main>
    </div>
  );
}

export default App;
